import './src/vaadin-dialog.js';
export * from './src/vaadin-dialog.js';
